import { render } from "./RealTimeChat.vue?vue&type=template&id=edeb9304&scoped=true"
import script from "./RealTimeChat.vue?vue&type=script&lang=js"
export * from "./RealTimeChat.vue?vue&type=script&lang=js"

import "./RealTimeChat.vue?vue&type=style&index=0&id=edeb9304&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edeb9304"]])

export default __exports__